import { styled } from "@volkswagen-onehub/components-core";
import { VWTheme } from "src/shared/typings/vw-theme";

export const StyledQrCodeContainer = styled.div`
    padding: ${({ theme }: { theme: VWTheme }) => theme.size.static350};
    border-radius: 8px;
    border: 2px solid ${({ theme }) => theme.colors.border.divider};
`;